const getTitleMenuStatistics = (t) => [
    {
        name: t('orders-menu-title-sample-deliveries'),
        linkForRoute: "deliveries"
    },
    {
        name: t('orders-menu-title-sample-orders'),
        linkForRoute: "orders"
    },
    {
        name: t('statistics-menu-title-sample-replacements'),
        linkForRoute: "replacements"
    },
    {
        name: t('aside-menu-item-dishes'),
        linkForRoute: "dishes"
    },
]

export {
    getTitleMenuStatistics,
}